import React from "react";
import ReactDOM from "react-dom/client";

/**
 * Import static files
 */
import "./index.css";

/**
 * Import Components
 */
import App from "./App";

import { FirestoreProvider } from "./contexts/FirestoreProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FirestoreProvider>
      <App />
    </FirestoreProvider>
  </React.StrictMode>
);
